import { BOARD_WIDTH, BOARD_HEIGHT } from './constants';

export type PieceType = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export interface Piece {
  type: PieceType;
  x: number;
  y: number;
  rotation: number;
}

export interface InputState {
  left: boolean;
  right: boolean;
  rotateCW: boolean;
  rotateCCW: boolean;
  softDrop: boolean;
  hardDrop: boolean;
  hold: boolean;
}

export interface DASState {
  direction: 'left' | 'right' | null;
  counter: number;
  charged: boolean;
}

export interface GameState {
  board: number[][];
  currentPiece: Piece | null;
  nextPiece: PieceType;
  heldPiece: PieceType | null;
  canHold: boolean;
  score: number;
  lines: number;
  level: number;
  dropTimer: number;
  lockTimer: number;
  isLocking: boolean;
  gameOver: boolean;
  bag: PieceType[];
}

export function createEmptyBoard(): number[][] {
  const board: number[][] = [];
  for (let y = 0; y < BOARD_HEIGHT; y++) {
    board.push(new Array(BOARD_WIDTH).fill(0));
  }
  return board;
}

export function createInitialState(): GameState {
  const bag = generateBag();
  const nextBag = generateBag();
  return {
    board: createEmptyBoard(),
    currentPiece: null,
    nextPiece: nextBag[0],
    heldPiece: null,
    canHold: true,
    score: 0,
    lines: 0,
    level: 1,
    dropTimer: 0,
    lockTimer: 0,
    isLocking: false,
    gameOver: false,
    bag: [...bag.slice(1), ...nextBag.slice(1)],
  };
}

function generateBag(): PieceType[] {
  const pieces: PieceType[] = [1, 2, 3, 4, 5, 6, 7];
  // Fisher-Yates shuffle
  for (let i = pieces.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pieces[i], pieces[j]] = [pieces[j], pieces[i]];
  }
  return pieces;
}

export function getNextPiece(state: GameState): PieceType {
  if (state.bag.length < 7) {
    state.bag.push(...generateBag());
  }
  return state.bag.shift()!;
}
